import { object } from 'prop-types';
import React, { useCallback, useState } from 'react';
import Select from 'react-select';
import { getSelectStyles } from '../../utils/react-select-style';

const CustomMultiSelect = ( props ) => {

    const { attributes } = props;
    const { width, height, data, variable, onSelectChange, isSearchable, defaultValue, placeholder,
        maxNumberSelection,
    } = attributes;

    const [ selectedOptions, setSelectedOptions ] = useState( null );
    const onValueChange = useCallback( ( e ) => {

        setSelectedOptions( e );
        onSelectChange( variable, e );

    } );

    return (
        <Select
            className="chart-selection"
            name="chart-selection"
            defaultValue={ defaultValue }
            options={ data }
            menuPortalTarget={ document.body }
            styles={ getSelectStyles( width, height, false, false, false, true ) }
            onChange={ onValueChange }
            isSearchable={ isSearchable }
            placeholder={ placeholder }
            isOptionDisabled={ () => selectedOptions && selectedOptions.length >= maxNumberSelection }
            isMulti={ true }
        />
    );

};

CustomMultiSelect.propTypes = {
    attributes: object,
};

export default CustomMultiSelect;
